// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EmdGender;
(function (EmdGender) {
    EmdGender["female"] = "F";
    EmdGender["male"] = "M";
    EmdGender["unknown"] = "U";
    EmdGender["other"] = "I";
})(EmdGender || (EmdGender = {}));
//# sourceMappingURL=emdGender.js.map